import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { keys } from "./keys";
import { ProviderTag, ProviderWithDetails } from "../types";

async function fetchProviderById(providerId: string): Promise<ProviderWithDetails> {
  const { data, error } = await apiClient
    .from('providers_view')
    .select(`*, provider_tag_assignments(provider_tags(*))`)
    .eq('id', providerId)
    .single();

  if (error) {
    throw error;
  }

  const rawTags = (data.provider_tag_assignments ?? [])
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((assignment: any) => assignment.provider_tags)
    .filter((tag: unknown): tag is ProviderTag => Boolean(tag));

  const tags = rawTags.sort((a: ProviderTag, b: ProviderTag) => a.name.localeCompare(b.name));

  return {
    id: data.id!,
    name: data.name!,
    description: data.description,
    address: data.address,
    user_id: data.user_id!,
    space_id: data.space_id!,
    created_at: data.created_at!,
    search_text: data.search_text,
    tags,
    hasActiveContract: Boolean(data.has_active_contract),
  };
}

export default function useGetProviderById(providerId: string | undefined) {
  return useQuery({
    queryKey: keys.getProviderById(providerId!),
    queryFn: () => fetchProviderById(providerId!),
    enabled: !!providerId,
    staleTime: _3_DAYS,
  });
}
